import { t } from "@lingui/macro";
import { CircleNotch, CursorClick, FilePdf } from "@phosphor-icons/react";
import { buttonVariants, Card, CardContent, CardDescription } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { saveAs } from "file-saver";

import { usePrintResume } from "@/client/services/resume/print";
import { useResumeStore } from "@/client/stores/resume";

import { SectionHeader } from "@/client/pages/builder/_components/SectionHeader";

const onJsonExport = () => {
  const { resume } = useResumeStore.getState();
  const filename = `reactive_resume-${resume.id}.json`;
  const resumeJSON = JSON.stringify(resume.data, null, 2);

  saveAs(new Blob([resumeJSON], { type: "application/json" }), filename);
};

const openInNewTab = (url: string) => {
  const win = window.open(url, "_blank");
  if (win) win.focus();
};

export const ExportSection = () => {
  const { printResume, loading } = usePrintResume();

  const onPdfExport = async () => {
    const { resume } = useResumeStore.getState();
    const { url } = await printResume({ id: resume.id });

    openInNewTab(url);
  };

  return (
    <section id="export" className="grid gap-y-6">
      <main className="grid gap-y-4">
        {/*<Card*/}
        {/*  className={cn(*/}
        {/*    buttonVariants({ variant: "ghost" }),*/}
        {/*    "h-auto cursor-pointer flex-row items-center gap-x-5 px-4 pt-1 pb-3",*/}
        {/*  )}*/}
        {/*  onClick={onJsonExport}*/}
        {/*>*/}
        {/*  <FileJs size={22} />*/}
        {/*  <CardContent className="flex-1">*/}
        {/*    <CardTitle className="text-sm">{t`JSON`}</CardTitle>*/}
        {/*    <CardDescription className="font-normal">*/}
        {/*      {t`Download a JSON snapshot of your resume. This file can be used to import your resume in the future, or can even be shared with others to collaborate.`}*/}
        {/*    </CardDescription>*/}
        {/*  </CardContent>*/}
        {/*</Card>*/}

        <Card
          className={cn(
            buttonVariants({ variant: "ghost" }),
            "h-auto cursor-pointer flex-row items-center gap-x-5 rounded-lg border-none p-2 py-4 pl-5 shadow-md",
            loading && "pointer-events-none cursor-progress opacity-75",
          )}
          onClick={onPdfExport}
        >
          {loading ? (
            <CircleNotch weight="bold" size={42} className="animate-spin" />
          ) : (
            <FilePdf className="mb-0" size={42} />
          )}

          <CardContent className="relative flex-1">
            <CardDescription className="font-normal">
              {t`Download a PDF of your resume to print, share with recruiters, or upload to job portals.`}

              <CursorClick weight="duotone" className="absolute right-2 bottom-0 size-5" />
            </CardDescription>
          </CardContent>
        </Card>
      </main>
    </section>
  );
};
